import { getRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function getOrderTemplatesRequest() {
	let url = orderTemplates.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}